module.exports = {"540530100":"错那镇","540530200":"卡达乡","540530201":"觉拉乡","540530202":"浪坡乡","540530203":"曲卓木乡","540530204":"库局乡","540530205":"麻麻门巴民族乡","540530206":"贡日门巴民族乡","540530207":"吉巴门巴民族乡","540530208":"勒门巴民族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540530.json
// module id = 2869
// module chunks = 0